import './modal-style.scss'

import React from 'react'
import Modal from 'react-modal'

import Button from './button-modal'

export default function CalendarModal({ children, isOpen, onRequestClose }) {
  return (
    <Modal
      className="container-modal"
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={onRequestClose}
      shouldCloseOnOverlayClick={true}
    >
      <h2>Add to Calendar</h2>
      <div>{children}</div>
      <Button style={{ backgroundColor: '#fff' }} onClick={onRequestClose}>
        Cancel
      </Button>
    </Modal>
  )
}
